// extracted by mini-css-extract-plugin
module.exports = {"dpuDetailL":"L_dpuDetailL__pSAJJ"};